import React from "react"
import {Form} from "formik";
import "./ads.css"

class Adform extends React.Component {

        state = {
            version: "",
            introText: "",
            destinationUrl: "",
            headline: ""
        };

    componentWillReceiveProps(nextProps, nextContext) {
        let introTextProp = "introText_" + this.props.version;
        let destinationUrl = "destinationUrl_" + this.props.version;
        let headlineProp = "headline_" + this.props.version;

        this.setState({
            version: this.props.version,
            introText: nextProps.data[introTextProp],
            destinationUrl: nextProps.data[destinationUrl],
            headline: nextProps.data[headlineProp],
        });

    }

    onFormChange(e) {
        this.setState(({...this.state, [e.target.name]: e.target.value}));
        this.props.onFormChange(this.props.version, e.target.name, e.target.value, e.target.selectionStart);
    }

    render() {
        return(
            <div className="upload-container">
                <Form className="upload-form">
                    <div className="space-between"></div>
                    <div className="input-group">
                        <label>
                            <span>Introductory Text </span>
                            <textarea id={"introText_" + this.state.version}
                                      name="introText"
                                      value={this.state.introText}
                                      onChange={this.onFormChange.bind(this)}
                                      className="text-descriptor"
                                      onClick={this.onFormChange.bind(this)}
                            />
                        </label>
                    </div>

                    <div className="space-between"></div>
                    <div className="input-group">
                        <label>
                            <span>Destination URL </span>
                            <input
                                id={"destinationUrl_" + this.state.version}
                                type="text"
                                name = "destinationUrl"
                                value={this.state.destinationUrl}
                                onChange={this.onFormChange.bind(this)}
                                placeholder="https://www.calltoaction.com"
                                className="landing-page-url text-descriptor"
                                onClick={this.onFormChange.bind(this)}
                            />
                        </label>
                    </div>

                    <div className="space-between"></div>

                    <div className="input-group">
                        <label>
                            <span>Headline </span>
                            <textarea
                                id={"headline_" + this.state.version}
                                name = "headline"
                                value={this.state.headline}
                                onChange={this.onFormChange.bind(this)}
                                className="text-descriptor"
                                onClick={this.onFormChange.bind(this)}
                            />
                        </label>
                    </div>
                </Form>
            </div>
        )
    }
}

export default Adform